import { Component, OnInit } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { IEnvironment } from "../../../../environments/environment.base";
import { TicketService } from "../../../services/ticket.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  constructor(private service: TicketService) {
    this.environment = environment;
  }

  environment: IEnvironment;
  apiVersion: any = null;
  webVersion = "2.0.1";

  ngOnInit() {
    this.service.apiVersion().subscribe((v) => (this.apiVersion = v));
  }
}
